var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as ServiceDocument from '../../services/document';
import * as ServiceUtils from '../../services/utils';
import { Loader } from '../../utils/Loader';
import { useState, useEffect } from 'react';
import { DocumentSchema } from '../../utils/ValidationSchema';
import { TYPES } from '../../utils/FormikTextField';
import { FormikGenerator } from '../../utils/FormikGenerator';
import { DocumentIcon } from '../../utils/Icons';
import { Modal } from '../../utils/Modal';
import { FileUpload } from '../../utils/FileUpload';
import { getBase64 } from '../../services/document';
export var EditionDocument = function (props) {
    var Model = props.Model, ModelId = props.ModelId, DocumentId = props.DocumentId, onChange = props.onChange;
    var _a = useState(null), document = _a[0], setDocument = _a[1];
    var _b = useState([]), typesDocument = _b[0], setTypesDocument = _b[1];
    var _c = useState(null), viewer = _c[0], setViewer = _c[1];
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    useEffect(function () {
        var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var datas;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            ServiceDocument.getDocument(DocumentId, Model, ModelId),
                            ServiceUtils.getTypes('Document'),
                        ])];
                    case 1:
                        datas = _a.sent();
                        setDocument(datas[0]);
                        setTypesDocument(datas[1]);
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        getData();
    }, []);
    var renderForm = function () {
        return (_jsx(FormikGenerator, { validationSchema: DocumentSchema, submitLabel: DocumentId ? 'Enregistrer' : 'Ajouter', datas: document, onSubmit: function (newDocument) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ServiceDocument.postDocument(__assign(__assign({}, document), newDocument))];
                        case 1:
                            _a.sent();
                            onChange();
                            return [2 /*return*/];
                    }
                });
            }); }, validate: function (_a) {
                var values = _a.values;
                if (!values.Base64) {
                    return 'Veuillez importer un document !';
                }
            }, fields: [
                [
                    {
                        name: 'Libelle',
                        label: 'Libelle',
                        type: TYPES.TEXT,
                        uppercaseFirstChar: true,
                    },
                    {
                        name: 'DocumentTypeId',
                        label: 'Type',
                        type: TYPES.SELECT,
                        options: typesDocument,
                    },
                ],
            ], renderContent: function (_a) {
                var values = _a.values, renderField = _a.renderField, setValues = _a.setValues;
                return (_jsx(FileUpload, { files: values.File ? [values.File] : [], onDrop: function (files) { return __awaiter(void 0, void 0, void 0, function () {
                        var file, base64;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    file = files[0];
                                    return [4 /*yield*/, getBase64(file)];
                                case 1:
                                    base64 = _a.sent();
                                    setValues(__assign(__assign({}, values), { Name: file.name, Type: file.type, Size: file.size, File: file, Base64: base64.replace("data:".concat(file.type, ";base64,"), '') }));
                                    return [2 /*return*/];
                            }
                        });
                    }); }, onRemove: function () {
                        setValues(__assign(__assign({}, values), { Name: null, Type: null, Size: null, File: null, Base64: null }));
                    } }));
            } }));
    };
    return (_jsx(_Fragment, { children: _jsx(Modal, __assign({ handleCloseModal: onChange, forceOpen: true, title: "Document", iconTitle: _jsx(DocumentIcon, {}) }, { children: loading ? _jsx(Loader, {}) : renderForm() })) }));
    /*
  
    {this.state.DocumentSelected.Base64 && (
    Name
  
    <DocumentViewer
    Type={this.state.DocumentSelected.Type}
    Base64={this.state.DocumentSelected.Base64.replace(
          'data:application/pdf;base64,',
          ''
      )}
    Name={this.state.DocumentSelected.Name}
    />
       */
};
//# sourceMappingURL=EditionDocument.js.map